import styled from 'styled-components';

const Image = styled.img`
  height: 10px;
  margin-right: 5px;
`;
const ContainerImage = styled.div`
  display: block;
  margin-left: ${({ marginHeader }) => (marginHeader ? '16px' : '6px')}; 
`;

export {
  Image,
  ContainerImage,
};
